module.exports = __webpack_public_path__ + "static/media/magic.cbbb3716.svg";